import React from 'react';
import { Variant } from '../CookieConsent';
import {
    StyledCookieConsentHeader,
    StyledCookieConsentParagraph,
    StyledCookieConsentTextArea,
} from '../CookieConsent.styles';
import { CookieConsentType } from '../CookieConsentType';
import cookieConsentData from '../cookieData';
import CookieSetting from '../CookieSetting/CookieSetting';
import ExternalLink from '../../ExternalLink/ExternalLink';

export const CookieConsentSettings = ({
    onChecked,
    isOptedIn,
    variant,
    expanded,
}: {
    onChecked: (value: boolean, id: CookieConsentType) => void;
    isOptedIn: (key: CookieConsentType) => boolean;
    variant: Variant;
    expanded: boolean;
}) => {
    const showOneLayer = variant === Variant.OneLayer || variant === Variant.OneLayerRejectAll;

    return (
        <>
            <StyledCookieConsentTextArea>
                <StyledCookieConsentHeader>
                    {showOneLayer
                        ? 'Vi vill ge dig en bättre upplevelse'
                        : 'Hantera dina cookie-inställningar'}
                </StyledCookieConsentHeader>
                {showOneLayer && (
                    <StyledCookieConsentParagraph id="cookie-desc">
                        Vi använder oss av cookies för att analysera hur SVT Play används, kunna erbjuda dig
                        personligt anpassat innehåll och marknadsföring. Vissa cookies kommer från företag vi
                        samarbetar med. Du kan när som helst ändra eller återkalla ditt medgivande.{' '}
                        <ExternalLink href="https://kontakt.svt.se/guide/cookies-och-personuppgifter">
                            Om cookies och personuppgifter
                        </ExternalLink>
                        .
                    </StyledCookieConsentParagraph>
                )}
            </StyledCookieConsentTextArea>
            <CookieSetting
                data={cookieConsentData.required_storage}
                id={CookieConsentType.REQUIRED}
                onChecked={onChecked}
            />
            <CookieSetting
                data={cookieConsentData.functionality_storage}
                id={CookieConsentType.FUNCTIONALITY}
                onChecked={onChecked}
                isCheckedBefore={isOptedIn(CookieConsentType.FUNCTIONALITY)}
                defaultExpanded={expanded}
            />
            <CookieSetting
                data={cookieConsentData.statistics_storage}
                id={CookieConsentType.STATISTICS}
                onChecked={onChecked}
                isCheckedBefore={isOptedIn(CookieConsentType.STATISTICS)}
            />
            <CookieSetting
                data={cookieConsentData.ad_storage}
                id={CookieConsentType.AD}
                onChecked={onChecked}
                isCheckedBefore={isOptedIn(CookieConsentType.AD)}
            />
        </>
    );
};
